import { produce } from 'immer';

const initialState = {
  formStatus: null,
};

export const FORM_STATE_SUCCESS = 'success';

export const FORM_STATE_ERROR = 'error';

export const FORM_STATE_LOADING = 'loading';

export default function (
  state = initialState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: { type: string; payload?: any; error?: boolean; meta?: any } = {
    type: '',
  }
) {
  switch (action.type) {
    case 'persist/REHYDRATE':
      return produce(state, (draft) => {
        draft.formStatus = null;
      });

    case 'FORM_SUBMIT':
      return produce(state, (draft) => {
        draft.formStatus = FORM_STATE_LOADING;
      });

    case 'FORM_SUBMIT_RESPONSE':
      return produce(state, (draft) => {
        draft.formStatus = FORM_STATE_SUCCESS;
      });

    case 'FORM_SUBMIT_RESPONSE_ERROR':
      return produce(state, (draft) => {
        draft.formStatus = FORM_STATE_ERROR;
      });

    default:
      return state;
  }
}
